import { render, staticRenderFns } from "./WorkBookQuestionsOpenAltTopEntry.vue?vue&type=template&id=02a4ccb2&scoped=true&"
import script from "./WorkBookQuestionsOpenAltTopEntry.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsOpenAltTopEntry.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsOpenAltTopEntry.vue?vue&type=style&index=0&id=02a4ccb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4ccb2",
  null
  
)

export default component.exports